(() => {
  if (!customElements.get('fs-video')) {
    customElements.define('fs-video', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController();
        this.querySelector('[data-play]')?.addEventListener('click', () => this.start(), {signal:this.abort.signal});
      }
      start() {
        if (this.querySelector('.fs__player')) return;
        document.dispatchEvent(new CustomEvent('foundry:media-play',{detail:this}));
        const template = this.querySelector('template'); if (!template) return;
        this.querySelector('[data-play]').hidden = true;
        this.appendChild(template.content.cloneNode(true));
        const player = this.querySelector('.fs__player');
        if (!player) { this.querySelector('[data-play]').hidden = false; return; }
        player.setAttribute('tabindex','0'); player.focus({preventScroll:true});
        if (player.tagName === 'VIDEO') {
          player.addEventListener('play', () => document.querySelectorAll('fs-video').forEach(other => {if(other!==this)other.stop();}), {signal:this.abort.signal});
          const playback=player.play(); if(playback?.catch)playback.catch(()=>{/* Native controls allow a retry. */});
        }
      }
      stop() {
        const player=this.querySelector('.fs__player');
        if(player?.tagName==='VIDEO')player.pause();
        player?.remove();
        const cover=this.querySelector('[data-play]');if(cover)cover.hidden=false;
      }
      disconnectedCallback(){this.stop();this.abort?.abort();}
    });
  }
  if (customElements.get('fs-section')) return;
  customElements.define('fs-section',class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
      const toggle=this.querySelector('[data-motion-toggle]');
      if(toggle&&this.querySelector('[data-motion="float"],[data-motion="sway"],.fs__animated')) {
        toggle.hidden=false;
        toggle.addEventListener('click',()=>{const paused=this.toggleAttribute('data-paused');toggle.setAttribute('aria-pressed',String(paused));toggle.textContent=paused?this.dataset.resumeLabel:this.dataset.pauseLabel;},{signal});
      }
      this.addEventListener('click',event=>{
        const choice=event.target.closest('[data-kit-select]');if(choice)this.selectKit(choice.dataset.kitSelect);
        const arrow=event.target.closest('[data-slide]');
        if(arrow&&this.track){const direction=getComputedStyle(this.track).direction==='rtl'?-1:1;this.track.scrollBy({left:Number(arrow.dataset.slide)*this.track.clientWidth*.85*direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
      },{signal});
      this.addEventListener('change',event=>{
        if(!event.target.matches('[data-variant]'))return;
        const selected=event.target.selectedOptions[0];const quantity=this.querySelector('[name="quantity"]');if(quantity){quantity.min=selected.dataset.min||'1';quantity.step=selected.dataset.step||'1';if(selected.dataset.max)quantity.max=selected.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;}const buy=this.querySelector('[data-buy]');
        this.querySelector('[data-price]').textContent=selected.dataset.price;
        const compare=this.querySelector('[data-compare]');compare.textContent=selected.dataset.compare;compare.hidden=!selected.dataset.compare;
        if(buy){buy.disabled=selected.dataset.available!=='true';buy.textContent=buy.disabled?this.dataset.soldOut:buy.dataset.label;}
      },{signal});
      const items=this.querySelector('.fs__items');if(items)items.hidden=false;
      this.track=this.querySelector('.fs__films');
      if(this.track){
        if(this.querySelector('.fs__arrows'))this.querySelector('.fs__arrows').hidden=false;
        this.track.addEventListener('scroll',()=>this.updateArrows(),{signal,passive:true});
        if(window.ResizeObserver){this.resize=new ResizeObserver(()=>this.updateArrows());this.resize.observe(this.track);}
        this.updateArrows();
        if(window.IntersectionObserver){this.visibility=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.stop();}),{root:this.track,threshold:0});this.track.querySelectorAll('fs-video').forEach(v=>this.visibility.observe(v));}
      }
      document.addEventListener('shopify:block:select',event=>{
        if(!this.contains(event.target))return;
        const choice=event.target.closest('[data-kit-select]');if(choice)this.selectKit(choice.dataset.kitSelect);
        this.querySelectorAll('.is-selected').forEach(el=>el.classList.remove('is-selected'));
        event.target.closest('.fs__decor')?.classList.add('is-selected');
        const film=event.target.closest('.fs__film');if(film)film.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
      },{signal});
    }
    selectKit(id){
      if(![...this.querySelectorAll('[data-kit-select]')].some(el=>el.dataset.kitSelect===id))return;
      this.querySelectorAll('[data-kit-select]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.kitSelect===id)));
      for(const panel of this.querySelectorAll('[data-kit-panel]')){panel.hidden=panel.dataset.kitPanel!==id;if(!panel.hidden)for(const template of panel.querySelectorAll('template[data-deferred-image]'))template.replaceWith(template.content.cloneNode(true));}
      this.querySelectorAll('[data-kit-description]').forEach(el=>el.hidden=el.dataset.kitDescription!==id);
    }
    updateArrows(){const position=Math.abs(this.track.scrollLeft);this.querySelector('[data-slide="-1"]').disabled=position<2;this.querySelector('[data-slide="1"]').disabled=position>=this.track.scrollWidth-this.track.clientWidth-2;}
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.visibility?.disconnect();}
  });
})();
